import { useQuery } from "@msuite/ui/query";
import { responseHandler } from "@msuite/ui/utils";
import { getProtocolCallRequestStatus } from "@msuite/utils/protocols";
import type { Nullable, ProtocolCallRequestEventList } from "@msuite/utils/types";
import { client } from "@/hono";

export function useProtocolCallRequestEvents(protocolId: Nullable<string>) {
	/** Query */
	const query = useQuery({
		queryKey: ["protocol", protocolId ?? "--", "call-request-events"],
		queryFn: async () => {
			if (!protocolId) throw new Error("No protocol ID");
			const response = await client.protocols[":protocolId"]["call-request-events"].$get({
				param: { protocolId },
			});
			const data = await responseHandler(response);
			return data.callRequestEvents as ProtocolCallRequestEventList;
		},
		enabled: !!protocolId,
	});

	/** Computed */
	const callRequestEvents = query.data;
	const status = getProtocolCallRequestStatus(callRequestEvents);

	/** Return */
	return { ...query, callRequestEvents, status };
}
